import type { ParsedArgs } from '../args.js';
import { CliError, ExitCode } from '../errors.js';
import type { CommandResult } from '../output.js';
import { withClient } from './common.js';

export async function rpcCommand(args: ParsedArgs): Promise<CommandResult> {
  const method = args.positionals[1];
  if (!method) throw new CliError('rpc requires <method> [json-params]', ExitCode.Usage);
  const rawParams = args.positionals[2];
  let params: unknown;
  if (rawParams) {
    try {
      params = JSON.parse(rawParams);
    } catch (error) {
      throw new CliError(
        `Invalid JSON params: ${error instanceof Error ? error.message : String(error)}`,
        ExitCode.Usage,
      );
    }
  }
  const data = await withClient(args.options, (client) => client.request(method, params));
  return { data };
}
